import React from 'react';
import './ContactUs.scss';
import ContactForm from '../../components/contact-form/ContactForm';
import {Helmet, HelmetProvider } from 'react-helmet-async';
import OgImage from '../../assets/img/Og.png';

function ContactUs({t, onFormSuccessSubmit, onFormFailSubmit}) {

  return (
    <HelmetProvider>
  <Helmet>
    <meta charSet="utf-8" />
    <title>{t("contactUs_og_title")}</title>
    <meta name="description" content={t("contactUs_og_description")}></meta>
    <meta property="og:title" content={t("contactUs_og_title")} />
    <meta property="og:description" content={t("contactUs_og_description")} />
    <meta property="og:image" content={OgImage} />
    <link rel="canonical" href="https://weexpert.io/" />
  </Helmet>
    <div className="contact-wrapper">
        <div className="contact-content">
            <div className="contact-description">
              <div className="contact-capture">
                  {t("contact_capture")}
              </div>
              <div className="contact-text">
                  {t("contact_decription")}
              </div>
              <div className="contact-bottom">
                <div className="botton-capture">
                  {t("contact_us_call")}
                </div>
                <div className="bottom-description">
                <a href="tel:+48 718 808 505">+48 718 808 505</a>
                </div>
                <div className="botton-capture">
                  Email:
                </div>
                <div className="bottom-description">
                  <a href="mailto:info@weexpert.io">info@weexpert.io</a>
                </div>
              </div>
            </div>
            <div className="contact-form">
            <ContactForm t={t} onFormSuccessSubmit={onFormSuccessSubmit} onFormFailSubmit={onFormFailSubmit}/>
            </div>
        </div>
    </div>
    </HelmetProvider>
  );
}

export default ContactUs;